import PropTypes from "prop-types";

const AttemptHistoryTable = ({ attempts, onViewAttempt }) => {
  const formatDuration = (seconds) => {
    if (seconds === undefined || seconds === null) {
      return "00:00";
    }

    const minutes = Math.floor(seconds / 60);

    const remainingSeconds = seconds % 60;

    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds,
    ).padStart(2, "0")}`;
  };

  const formatDate = (date) => {
    if (!date) {
      return "-";
    }

    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const handleViewAttempt = (id) => {
    if (onViewAttempt) {
      onViewAttempt(id);
    }
  };

  if (!attempts || attempts.length === 0) {
    return (
      <div className="bg-white rounded-lg border p-5 text-center text-gray-500">
        No quiz attempts found.
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border overflow-hidden">
      <div className="p-4 border-b">
        <h2 className="text-lg font-semibold text-gray-800">
          My Quiz Attempts
        </h2>
      </div>

      {/* Desktop Table */}

      <div className="hidden md:block overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                Quiz
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Attempt
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Score
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Result
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Duration
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Date
              </th>

              <th className="px-4 py-3 text-center text-sm font-semibold text-gray-600">
                Action
              </th>
            </tr>
          </thead>

          <tbody className="divide-y">
            {attempts.map((attempt) => (
              <tr key={attempt._id} className="hover:bg-gray-50">
                <td className="px-4 py-3 text-sm text-gray-800">
                  {attempt.quiz?.name || "Quiz"}
                </td>

                <td className="px-4 py-3 text-sm text-center text-gray-700">
                  #{attempt.attemptNumber || "-"}
                </td>

                <td className="px-4 py-3 text-sm text-center font-medium">
                  {attempt.obtainedMarks ?? 0}/{attempt.totalMarks ?? 0}
                </td>

                <td className="px-4 py-3 text-center">
                  <span
                    className={`
                      px-3
                      py-1
                      rounded-full
                      text-xs
                      font-semibold

                      ${
                        attempt.result === "pass"
                          ? "bg-green-100 text-green-700"
                          : attempt.result === "fail"
                            ? "bg-red-100 text-red-700"
                            : "bg-gray-100 text-gray-700"
                      }
                    `}
                  >
                    {attempt.result ? attempt.result.toUpperCase() : "PENDING"}
                  </span>
                </td>

                <td className="px-4 py-3 text-sm text-center text-gray-700">
                  {formatDuration(attempt.durationSeconds)}
                </td>

                <td className="px-4 py-3 text-sm text-center text-gray-700">
                  {formatDate(attempt.createdAt)}
                </td>

                <td className="px-4 py-3 text-center">
                  <button
                    type="button"
                    onClick={() => handleViewAttempt(attempt._id)}
                    className="
                      text-blue-600
                      hover:text-blue-800
                      text-sm
                      font-medium
                    "
                  >
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Cards */}

      <div className="md:hidden p-4 space-y-3">
        {attempts.map((attempt) => (
          <div key={attempt._id} className="border rounded-lg p-4">
            <h3 className="font-semibold text-gray-800">
              {attempt.quiz?.name || "Quiz"}
            </h3>

            <div className="mt-2 text-sm text-gray-600 space-y-1">
              <p>Attempt: #{attempt.attemptNumber || "-"}</p>

              <p>
                Score: {attempt.obtainedMarks ?? 0}/{attempt.totalMarks ?? 0}
              </p>

              <p>Duration: {formatDuration(attempt.durationSeconds)}</p>

              <p>Date: {formatDate(attempt.createdAt)}</p>
            </div>

            <button
              type="button"
              onClick={() => handleViewAttempt(attempt._id)}
              className="
                mt-3
                w-full
                bg-blue-600
                text-white
                rounded-lg
                py-2
                text-sm
                font-medium
              "
            >
              View Result
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

AttemptHistoryTable.propTypes = {
  attempts: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,

      attemptNumber: PropTypes.number,

      obtainedMarks: PropTypes.number,

      totalMarks: PropTypes.number,

      result: PropTypes.string,

      durationSeconds: PropTypes.number,

      createdAt: PropTypes.string,

      quiz: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
  ),

  onViewAttempt: PropTypes.func,
};

AttemptHistoryTable.defaultProps = {
  attempts: [],
  onViewAttempt: undefined,
};

export default AttemptHistoryTable;
